import React from "react";
import { connect } from "react-redux";
import { formValueSelector, reduxForm, Field } from "redux-form";
import { Dates, Masks } from "../constants/enums";
import { required, normalizeMoney, formatDate } from "../utility";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import { calculateDelta,
         calculatePenalty,
         calculatePenaltyPerDay } from "../businessLogic";
import SubmitButton from './SubmitButton';
import Button from '@material-ui/core/Button';
import Divider from "@material-ui/core/Divider";
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const editDebtForm = ({ contractId, onEditDebt, handleSubmit}) => (
    <form className="common-form" onSubmit={handleSubmit(data => onEditDebt(contractId, {penaltySum: +(`${data.penaltySum}`).replace(/\s/g,``)}))} >
        <Field component={MaterialTextField}
               validate={required}
               format={normalizeMoney}
               endAdornment="₽"
               name="penaltySum"
               label="Сумма долга" />
        <SubmitButton label="Сохранить" />
    </form>
);

const EditDebtForm = connect(
    (state, props) => {
        const { penaltySum } = props;
        return {
            initialValues: {
                penaltySum: normalizeMoney(penaltySum)
            },
        };
    },
    null
)(reduxForm({ form: "edit-debt-form", enableReinitialize: true })(editDebtForm));


const editPenaltyForm = ({ contractId, inputFrozenDays, penaltyFrozen, onPenaltyUnfreeze, onPenaltyFreeze, handleSubmit }) => (
    <form className="common-form common-column" onSubmit={handleSubmit(data => penaltyFrozen ? onPenaltyUnfreeze(contractId, data) : onPenaltyFreeze(contractId, data) )} >
        {penaltyFrozen ?
            <Field name="frozenDays"
               component={MaterialTextField}
               label="Заморозить дней" />
            :
            <Field name="freezeDate"
               component={MaterialMaskedTextField}
               mask={Masks.date}
               label="Дата заморозки" />
        }
        <Button type="submit"
                size="large"
                color="primary"
                disabled={penaltyFrozen && (inputFrozenDays < 1 || isNaN(Number(inputFrozenDays)))}
                variant="contained">
                {penaltyFrozen ? `Разморозить начисление штрафа` : `Заморозить начисление штрафа` }
        </Button>
    </form>
);

const EditPenaltyForm = connect(
    (state, props) => {
        const { today, frozenDays } = props;

        return {
            inputFrozenDays: formValueSelector("edit-penalty-form")(state, "frozenDays"),
            initialValues: {
                frozenDays: frozenDays,
                freezeDate: formatDate(new Date(today))
            },
        };
    },
    null
)(reduxForm({ form: "edit-penalty-form", enableReinitialize: true })(editPenaltyForm));

class EditDebt extends React.Component {
    render() {
        const {
            contractId,
            sum,
            penaltySum,
            isLT,
            prolongationDate,
            closingDate,
            penaltyFrozen,
            penaltyFrozenDays = 0,
            penaltyFreezingDate,
            onEditDebt,
            onPenaltyFreeze,
            onPenaltyUnfreeze } = this.props;
        const today = Number(new Date().setHours(0,0,0,0));
        const pDate = Number(new Date(prolongationDate).setHours(0,0,0,0));
        const pFDate = Number(new Date(penaltyFreezingDate).setHours(0,0,0,0));
        const expiredDays = Math.floor((isLT ? (today - new Date(pDate + Dates._31Days)) : ( today - pDate) ) / Dates._1Day);
        const frozenDays = Math.floor( ( today - pFDate ) / Dates._1Day);
        const exemptionDate = new Date(pDate + Dates._31Days);
        const delta = calculateDelta(isLT, (closingDate || today), exemptionDate, pDate);
        const penalty = calculatePenalty(isLT, sum, delta);
        const penaltyPerDay = calculatePenaltyPerDay(isLT, sum);

        return (
            <Paper className="common-paper m20">
                <Grid container justify="center" spacing={16}>
                    <Grid item className="common-column">
                        <Typography variant="h5" gutterBottom>Долг по штрафам:</Typography>
                        <EditDebtForm contractId={contractId} penaltySum={penaltySum} onEditDebt={onEditDebt} />
                    </Grid>
                    {!isLT &&
                        <Grid item className="ultrawide-column">
                            <Typography variant="h5" gutterBottom>Управление:</Typography>
                            <Typography paragraph>Дата требуемой пролонгации: {formatDate(new Date(prolongationDate))}</Typography>
                            <Typography paragraph>Просрочено дней: {expiredDays - penaltyFrozenDays}{penaltyFrozenDays > 0 ? ` = ${expiredDays} - ${penaltyFrozenDays} (замороженных дней)` : ""}</Typography>
                            {penaltyFrozenDays > 0 && <Typography paragraph>Начисление штрафов было заморожено на {penaltyFrozenDays} дней</Typography>}
                            {penaltyFrozenDays > 0 && <Typography paragraph></Typography>}
                            <Typography paragraph>Штраф(в день, льготный): {normalizeMoney(penaltyPerDay)} ₽ = {normalizeMoney(sum)} ₽ (сумма займа) * 0.015 / 5</Typography>
                            <Typography paragraph>Штраф(итого, льготный): {normalizeMoney(penalty)} ₽ = {expiredDays - penaltyFrozenDays}{(expiredDays - penaltyFrozenDays) >= 0 ? "" : "(0)"} * {normalizeMoney(penaltyPerDay)} ₽</Typography>
                            <Divider style={{ marginBottom: 20 }} />
                            {penaltyFrozen && <Typography paragraph>Начисление штрафа было заморожено {formatDate(new Date(penaltyFreezingDate))}</Typography>}
                            {penaltyFrozen && <Typography paragraph>Текущий период заморозки составляет {frozenDays} дней</Typography>}
                            <EditPenaltyForm onPenaltyUnfreeze={onPenaltyUnfreeze}
                                             today={today}
                                             frozenDays={frozenDays}
                                             contractId={contractId}
                                             penaltyFrozen={penaltyFrozen}
                                             onPenaltyFreeze={onPenaltyFreeze} />
                        </Grid>
                    }
                </Grid>
            </Paper>
        );
    }
}

export default EditDebt;



// WEBPACK FOOTER //
// ./src/components/EditDebt.js